import React from 'react';

export const UploadIcon = () => (
  <svg width="52" height="35" viewBox="0 0 52 35" fill="none">
    <path
      d="M19.0375 9.00295C19.0375 9.00295 22.2167 -1.01635 32.6596 0.0844982C44.8306 1.64845 43.8591 15.3497 43.8569 15.3803C43.8569 15.3803 52.5352 17.2083 51.9739 26.4832C50.7965 34.9538 42.4202 34.9555 42.3982 34.9555L29.5183 35H23.4337L9.20913 34.9555C9.18654 34.9553 0.188389 34.8548 0 25.9508C2.46384e-05 17.0246 8.48211 15.3222 8.48211 15.3222C8.48089 15.3141 7.81019 10.8632 11.6264 8.43127C15.8932 5.88096 19.0375 9.00295 19.0375 9.00295Z"
      fill="#88B2E2"
    />
    <path
      d="M28.0932 10.9268C27.9686 10.7843 27.7927 10.7031 27.6081 10.7031C27.4235 10.7031 27.2476 10.7843 27.123 10.9268L23.6175 14.9383C23.3726 15.2186 23.3912 15.6536 23.6591 15.9099C23.927 16.1662 24.3427 16.1467 24.5877 15.8664L26.9508 13.1621V23.3109C26.9508 23.6907 27.2451 23.9986 27.6081 23.9986C27.9711 23.9986 28.2654 23.6907 28.2654 23.3109V13.1621L30.6285 15.8664C30.8735 16.1467 31.2892 16.1662 31.5571 15.9099C31.8251 15.6536 31.8436 15.2186 31.5987 14.9383L28.0932 10.9268Z"
      fill="white"
    />
    <path
      d="M19.8087 22.3458C19.8087 21.9542 19.4913 21.6367 19.0997 21.6367C18.7081 21.6367 18.3907 21.9542 18.3907 22.3458V22.3977C18.3906 23.6907 18.3906 24.7329 18.5008 25.5526C18.6152 26.4036 18.86 27.1201 19.429 27.6891C19.9981 28.2583 20.7146 28.5031 21.5655 28.6175C22.3852 28.7276 23.4273 28.7276 24.7202 28.7276H30.4964C31.7893 28.7276 32.8314 28.7276 33.6511 28.6175C34.502 28.5031 35.2184 28.2583 35.7876 27.6891C36.3566 27.1201 36.6013 26.4036 36.7157 25.5526C36.8259 24.7329 36.8259 23.6907 36.8259 22.3977V22.3458C36.8259 21.9542 36.5084 21.6367 36.1168 21.6367C35.7253 21.6367 35.4078 21.9542 35.4078 22.3458C35.4078 23.7029 35.4063 24.6494 35.3103 25.3636C35.217 26.0574 35.0465 26.4247 34.7848 26.6864C34.5231 26.9481 34.1558 27.1187 33.4621 27.212C32.7479 27.3079 31.8015 27.3094 30.4445 27.3094H24.7721C23.415 27.3094 22.4686 27.3079 21.7545 27.212C21.0608 27.1187 20.6934 26.9481 20.4318 26.6864C20.1701 26.4247 19.9995 26.0574 19.9063 25.3636C19.8102 24.6494 19.8087 23.7029 19.8087 22.3458Z"
      fill="white"
    />
  </svg>
);

export const RemoveIcon = (props) => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" {...props}>
    <circle cx="13.5" cy="13.5" r="13.5" fill="#D70000" />
    <g transform="translate(8 8)">
      <path
        d="M8.81895 0.434184C9.39786 -0.144728 10.3367 -0.144728 10.9156 0.434184C11.4944 1.0131 11.4945 1.95102 10.9156 2.52989L7.71836 5.72715L10.9156 8.92442C11.4945 9.50333 11.4945 10.4422 10.9156 11.0211C10.3367 11.6 9.39784 11.6 8.81895 11.0211L5.62168 7.82286L2.52989 10.9156C1.95102 11.4945 1.0131 11.4944 0.434184 10.9156C-0.144728 10.3367 -0.144728 9.39786 0.434184 8.81895L3.525 5.72715L0.434184 2.63536C-0.144728 2.05644 -0.144728 1.11759 0.434184 0.538676C1.01302 -0.0397009 1.95109 -0.0397763 2.52989 0.538676L5.62168 3.63047L8.81895 0.434184Z"
        fill="white"
      />
    </g>
  </svg>
);

export const PlayIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <circle cx="14" cy="14" r="13.5" stroke="white" />
    <path
      d="M10.4056 8.95077C10.4041 8.18097 11.2365 7.69822 11.9039 8.08182L20.4378 12.9868C21.1053 13.3704 21.1071 14.3326 20.4412 14.7188L11.9264 19.657C11.2605 20.0432 10.4262 19.5637 10.4247 18.7939L10.4056 8.95077Z"
      fill="#D9D9D9"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="19" height="15" viewBox="0 0 19 15" fill="none">
    <path
      d="M16.0965 0L6.5965 9.30839L2.90364 5.69036L0 8.536L6.59656 15L19 2.8457L16.0965 0Z"
      fill="#041942"
    />
  </svg>
);

export const PhoneErrorIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#F9524D" />
    <path
      d="M10.9444 5L10.7407 12.555H9.25926L9.04938 5H10.9444ZM9 14.894C9 14.5752 9.09053 14.3111 9.27161 14.1019C9.4568 13.8877 9.69959 13.7806 10 13.7806C10.3045 13.7806 10.5473 13.8877 10.7284 14.1019C10.9095 14.3111 11 14.5752 11 14.894C11 15.2029 10.9095 15.4644 10.7284 15.6787C10.5473 15.8929 10.3045 16 10 16C9.69959 16 9.4568 15.8929 9.27161 15.6787C9.09053 15.4644 9 15.2029 9 14.894Z"
      fill="white"
    />
  </svg>
);
